import { RefObject, useEffect } from 'react';

const useElementScrollTracker = ({
  trigger,
  ref,
  callback,
}: {
  trigger: boolean;
  ref: RefObject<HTMLElement>;
  callback?: (...args: any[]) => void;
}) => {
  useEffect(() => {
    if (trigger && ref.current) {
      const { scrollTop, clientHeight, scrollHeight } = ref.current;
      if (scrollTop === 0 && clientHeight === scrollHeight && trigger) {
        void callback?.();
      }
    }
  }, [trigger, callback]);
  return null;
};

export default useElementScrollTracker;
